/** The message the API sent back, or a plain fallback. */
export function apiErrorText(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: unknown; status?: number } };
  const data = e?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') {
    const d = data as { error?: unknown; message?: unknown; title?: unknown };
    for (const v of [d.error, d.message, d.title]) if (typeof v === 'string' && v.trim()) return v;
  }
  if (e?.response?.status === 403) return 'You do not have permission to do this.';
  return fallback;
}
